module.exports = __webpack_public_path__ + "08_mole.6b307eae.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer2/08_mole.png
// module id = Sqgg
// module chunks = 0